import { render, staticRenderFns } from "./LeaseScheduledPaymentsTabScreen.vue?vue&type=template&id=7a0159cb&"
import script from "./LeaseScheduledPaymentsTabScreen.vue?vue&type=script&lang=js&"
export * from "./LeaseScheduledPaymentsTabScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a0159cb')) {
      api.createRecord('7a0159cb', component.options)
    } else {
      api.reload('7a0159cb', component.options)
    }
    module.hot.accept("./LeaseScheduledPaymentsTabScreen.vue?vue&type=template&id=7a0159cb&", function () {
      api.rerender('7a0159cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/screens/LeaseDetailsScreen/LeaseScheduledPaymentsTabScreen.vue"
export default component.exports